module.exports = "/_next/static/images/StartTODAYLogo-8f776c28fdd35bc0cf99593f11aeda55.svg";